import React from 'react';
import { Select } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import Style from './refund.module.css';

export default function RefundAdditionalContent({ actionInstance = null }) {
    const { t } = useTranslation();
    const [refundType, setRefundType] = React.useState(actionInstance.refund_type);
    const optionsRefund = [
        {
            key: '0',
            text: t('ticket.manager.modalAction.dropdown.ticket_and_product'),
            value: 'all'
        },
        {
            key: 'tickets_only',
            text: t('ticket.manager.modalAction.dropdown.ticket_only'),
            value: 'ticket_only'
        },
        {
            key: 'products_only',
            text: t('ticket.manager.modalAction.dropdown.product_only'),
            value: 'products_only'
        }
    ];

    const _onChange = React.useCallback(
        value => {
            actionInstance.setRefundType(value);
            setRefundType(value);
        },
        [actionInstance]
    );

    return (
        <div className={Style['additional-content-box']}>
            <div className={Style['additional-content-box-title']}>{t('ticket.manager.modalAction.dropdown.dropdown_label')}</div>
            <Select useNew onChange={_onChange} options={optionsRefund} value={refundType} />
        </div>
    );
}
